import React, { useContext, useState } from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { ThemeContext } from "../../container/mppmodal/MppInfo";
import PriceInput from "./PriceInput";
import Spinner from "../MPPSpinner";

const ProductInfo = () => {
  const {
    ProductDetails: { details },
    brandings: { setPaycreditCardImage, creditCardImage },
    isMerchantApiFailed,
    isSpinnerDisplayed,
    mppFromEmail,
    isSetPayIn4Alone,
    subtitlempp,
    mppConfig: { mppApplicationLinkFlag },
  } = useContext(ThemeContext);

  const [offersDisplay, setOffersDisplay] = useState(true);
  return (
    <React.Fragment>
      <div className={mppFromEmail ? "email-product-modal-body modal-offer-content" : "modal-body modal-offer-content"} role="status" aria-live="polite">

        <>
          <h1 className="bodayHeader mb-1">
            {
              mppApplicationLinkFlag
                ? <b>Enter An Amount To Compare Financing Options</b>
                : <b>Enter An Amount To Finance</b>
            }
          </h1>
          {
            !mppApplicationLinkFlag &&
            (<div className="availableSub-heading mt-0">
              {subtitlempp}
            </div>)
          }
          <PriceInput setOffersDisplay={setOffersDisplay} />
        </>


        {offersDisplay && !isMerchantApiFailed && (
          <>
            <Container
              className={mppFromEmail ? "ml-0 p-0 emailProductDetails onlyMediaScreen" : "ml-0 p-0 productDetails onlyMediaScreen"}
              fluid={true}
            >
              {details.map((item, i) => {
                return (
                  <div className="content-block" key={i}>
                    <img
                      src={
                        item.productType === "REVOLVING"
                          ? creditCardImage
                          : setPaycreditCardImage
                      }
                      className={(item.productType === "SetPAY" || item.productType === "SetPAYIn4") ? "syfImageProductPage" : "setPayImgProductPage"}
                      alt=""
                    />
                    <div className="product-info">
                      <p className="product-title">{item.clientTitle}</p>
                      <div className="product-desc">
                        {item.clientDisclosureLanguage}
                      </div>
                    </div>
                  </div>
                );
              })}
            </Container>
          </>
        )}
      </div>
      <Spinner isDisplayed={isSpinnerDisplayed}></Spinner>
    </React.Fragment>
  );
};

export default ProductInfo;
